//#region import libraries
import React, { useEffect, useState } from 'react';

// custom components
import { TextLabel, CustomDivider } from '_atoms';
import { StarRating } from '_molecules';

// redux
import { useSelector, useDispatch } from 'react-redux'
import { selectSelectedBooking, selectBookingReview } from '../../../redux/slices/profile/user-profile'
import { selectAirportInformation, getAirportInformation } from '_redux/slices/analytics/reviews';

// bootstrap
import { Row, Col, Container, Form } from 'react-bootstrap';

// tremor
import { Subtitle } from '@tremor/react';

// styles
import { Colors } from '_styles';
//#endregion

const BookingDetails = (props) => {
    //#region redux
    const dispatch = useDispatch();

    const booking = useSelector(selectSelectedBooking);
    const bookingReview = useSelector(selectBookingReview);
    const airportInformation = useSelector(selectAirportInformation)
    //#endregion

    //#region local state
    const [departureAirport, setDepartureAirport] = useState('')
    const [arrivalAirport, setArrivalAirport] = useState('')
    //#endregion

    // get airport name
    useEffect(() => {
        if (booking) {
            if (booking && booking.origin && booking.destination) {

                // check if airport name exsists
                if (airportInformation && airportInformation[booking.origin]) {
                    setDepartureAirport(airportInformation[booking.origin].name)
                }
                else {
                    // get departure airport info
                    dispatch(getAirportInformation(booking.origin))
                }

                if (airportInformation && airportInformation[booking.destination]) {
                    setArrivalAirport(airportInformation[booking.destination].name)
                }
                else {
                    // get departure airport info
                    dispatch(getAirportInformation(booking.destination))
                }
            }
        }
    }, [booking, airportInformation])

    return (
        <Container className='mt-5'>
            <Row>

                <Subtitle>Passenger Information</Subtitle>
                <Row>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Name'}>{booking && booking.name ? booking.name : ''}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Bio'}>{booking && booking.bio ? booking.bio : ''}</TextLabel>
                    </Col>
                </Row>

                <CustomDivider />

                <Subtitle className='mt-5'>Flight Information</Subtitle>
                <Row className='mt-2'>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Flight'}>{booking && booking.flightNumber ? booking.flightNumber : ''}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Departure Date'}>{booking && booking.departureDate ? booking.departureDate : ''}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Departure'}>{departureAirport}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Arrival'}>{arrivalAirport}</TextLabel>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Departure Time'}>{booking && booking.departureTime ? booking.departureTime : ''}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Arrival Time'}>{booking && booking.arrivalTime ? booking.arrivalTime : ''}</TextLabel>
                    </Col>
                </Row>

                <CustomDivider />

                <Subtitle>Booking Request Information</Subtitle>
                <Row className='mt-2'>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Destination Assistance Requested'}>{booking && booking.destinationAssistance ? 'Departure Assistance Requested' : 'No Departure Assistance Required'}
                        </TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Arrival Assistance Requested'}>{booking && booking.arrivalAssistance ? 'Arrival Assistance Requested' : 'No Arrival Assistance Required'}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Destination Confirmed'}>{booking && booking.destinationConfirmed ? booking.destinationConfirmed : ''}</TextLabel>
                    </Col>
                    <Col>
                        <TextLabel
                            disabled={true}
                            label={'Arrival Confirmed'}>{booking && booking.arrivalConfirmed ? booking.arrivalConfirmed : ''}</TextLabel>
                    </Col>
                </Row>

                <CustomDivider />
                <Subtitle>Flight Review Information</Subtitle>
                <Row className='mt-2'>
                    {
                        bookingReview ?
                            <>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Departure Airport Assistance'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.departure ? bookingReview.departure.review.quality : ''} />
                                    </Col>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Departure Airport Staff'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.departure ? bookingReview.departure.review.staff : ''} />
                                    </Col>
                                    <Col>
                                        <TextLabel
                                            disabled={true}
                                            label={'Departure Airport Comments'}>{bookingReview && bookingReview.departure ? bookingReview.departure.review.comments : ''}
                                        </TextLabel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Arrival Airport Assistance'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.arrival ? bookingReview.arrival.review.quality : ''} />
                                    </Col>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Arrival Airport Staff'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.arrival ? bookingReview.arrival.review.staff : ''} />
                                    </Col>
                                    <Col>
                                        <TextLabel
                                            disabled={true}
                                            label={'Arrival Airport Comments'}>{bookingReview && bookingReview.arrival ? bookingReview.arrival.review.comments : ''}
                                        </TextLabel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Airline Boarding Assistance'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.flight ? bookingReview.flight.review.boarding : ''} />
                                    </Col>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Airline Onboard Staff'}</Form.Label>
                                        <StarRating stars={bookingReview && bookingReview.flight ? bookingReview.flight.review.onboard : ''} />
                                    </Col>
                                    <Col>
                                        <TextLabel
                                            disabled={true}
                                            label={'Arrival Airport Comments'}>{bookingReview && bookingReview.flight ? bookingReview.flight.review.comments : ''}
                                        </TextLabel>
                                    </Col>
                                </Row>
                            </>
                            :
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'No Review Submitted'}</Form.Label>
                    }
                </Row>

            </Row>
        </Container>
    );
};

export default BookingDetails;
